Pegasus.MainTabPanelController = Ember.Controller.extend({
});
